<script>
    /* Imports */
    import FormularovePolicko from "./RezervacniFormular/FormularovePolicko.svelte";
    import TerminovyKalendar from "./RezervacniFormular/TerminovyKalendar.svelte";
    import { onMount } from 'svelte';
    import { APIrequestPOST } from "./js_libs/API_calls.js";
    import { shared_kontakty, shared_rezervacni_mista } from "./js_libs/SharedInformation.js";
  import BlokNacitani from "./BlokNacitani.svelte";

    /* Props */
    // Informace pro chybové hlášky rezervančního formuláře
    export const kontakty = {
        telefon : "+420 123 456 789",
        email: "administrace@hraza.cz"
    };

    // Rezervační místa, která lze kontaktovat s formulářem (API POINT - RES PLACE PARAMETER)
    export const rezervacni_mista = [
        {
            id: "hraza",
            nazev: "Hráza",
        }
    ]

    /* Vlastnosti rezervačního formuláře */
    let JmenoZakaznika;
    let EmailZakaznika;
    let TelefonZakaznika;
    let PoznamkaZakaznika;
    let VybraneRezervaceZakaznika = [];

    let odpovedi = "";

    let ChybovyVyber;

    /* Funkce rezervačního formuláře */
    onMount(() => 
        {
            // $shared_kontakty = kontakty;
            // $shared_rezervacni_mista = w;
            
        }
    )


    /**
     * Validace formuláře
     * @returns {boolean} true, pokud je formulář validní, jinak false
     * @description Tato funkce provádí validaci formuláře a vrací true, pokud jsou všechna pole vyplněna správně.
     * Pokud některé pole není vyplněno, zobrazí se chybová hláška a vrátí false.
     */
    function ValidaceFormulare() 
    {
        if(JmenoZakaznika?.length <= 0 || JmenoZakaznika === "" || !JmenoZakaznika.includes(" "))
        {
            console.error("Nevalidní formulář - Jméno zákazníka");
            return false;
        }
        else if(TelefonZakaznika?.length < 9 || TelefonZakaznika === "")
        {    
            console.error("Nevalidní formulář - Telefon");
            return false;
        }
        else if(EmailZakaznika?.length <= 0 || EmailZakaznika === "" || !(EmailZakaznika.includes("@") || EmailZakaznika.includes(".")))
        {
            console.error("Nevalidní formulář - Email");
            return false;
        }
        else if (VybraneRezervaceZakaznika?.length <= 0) 
        {
            console.error("Nevalidní formulář - Výběr rezervace");
            return false;
        }
        else if (ChybovyVyber) {
            console.error("Nevalidní formulář - Výběr obsahuje nemožné rezervace");
            return false;
        }
            
        

        return true;
    }

    /**
     * Odeslání formuláře
     * @returns {void}
     * @description Tato funkce odesílá formulář a provádí validaci. Pokud je formulář validní, odešle data na server.
     */
    async function OdeslatFormular()
    {
        
        if(ValidaceFormulare() === true) 
        {
            let data = [];

            const terminy = VybraneRezervaceZakaznika;            

            let dataRequest = {
                "res_uuid": rezervacni_mista[0].id,
                "email": EmailZakaznika,
                "phone": TelefonZakaznika,
                "name" : JmenoZakaznika
            };

            dataRequest['dates'] = terminy.map((termin) => {
                return termin.start_time.slice(0, 10)
            });
            
            data = APIrequestPOST(
                "reserveMultiple",
                dataRequest
            );

            odpovedi = await data;
            console.log("Úspěšně zarezervováno!");
            console.log(await odpovedi);
        }
        else 
        {
            console.log("Nevalidní formulář.");
        }
    }

</script>

{#if odpovedi.length > 0}
<div style="min-height: 800px;">
     {#await odpovedi}
        <BlokNacitani height={"800px"} />
     {:then answer} 
        <div style="background-color: #C8E6C9; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #66BB6A;  margin: 20px 0 20px 0;">
            <strong>Úspěch!</strong> Rezervace byla vytvořena!
        </div>
    {:catch error}
        <div style="background-color: #FFCCCC; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #FFA07A; margin: 20px 0 20px 0;">
            <strong>Chyba:</strong> Došlo k chybě při vytváření rezervace. Rezervace nebyla vytvořena. Pro rezervaci volejte na tel. číslo <strong>uvedené níže</strong> nebo to zkuste znovu.<br/>
            {error}
        </div>        
     {/await}
</div>
{:else}
<form 
    class="rezervacni-formular"
    style="display: flex; flex-direction: column; gap: 1.5rem; padding-bottom: 1.5rem;"
    on:submit|preventDefault={() => {OdeslatFormular()}}
    >

    <input 
        type="hidden"
        id="rezervacni-misto"
        name="rezervacni-misto"
        value={rezervacni_mista[0].id} 
        />

    <!-- Výběr termínu -->
    <TerminovyKalendar 
        bind:VybraneRezervaceZakaznika
        bind:ChybovyVyber
    />
    {#if VybraneRezervaceZakaznika?.length <= 0}
        {#if ChybovyVyber}
            <p style="color:red;">Vybrané termíny nelze zarezervovat z důvodu plné kapacity nebo neplatného data.</p>
        {:else}
            <p style="color:red;">Vyberte prosím Váš termín rezervace.</p>
        {/if}
    {/if}


    <FormularovePolicko 
        labelTitle="Jméno a příjmení"
        placeholder="Zadejte své jméno a příjmení"
        id="jmeno-zakaznika"
        required={true}
        bind:value={JmenoZakaznika} 
    />

    <FormularovePolicko 
        labelTitle="Email"
        placeholder="Zadejte email"
        id="email-zakaznika"
        required={true}
        bind:value={EmailZakaznika} 
    />

    {#if EmailZakaznika?.length > 0 && !(EmailZakaznika.includes("@") || EmailZakaznika.includes(".")) }
        <p style="color:red;">Email musí být ve formátu email@domena.cz</p>
    {/if}

    <FormularovePolicko 
        labelTitle="Telefonní číslo"
        placeholder="Zadejte telefonní číslo"
        id="telefon-zakaznika"
        required={true}
        type="tel"
        bind:value={TelefonZakaznika} 
    />

    {#if TelefonZakaznika?.length > 0 && TelefonZakaznika?.length < 9 }
        <p style="color:red;">Telefonní číslo musí obsahovat alespoň 9 číslic.</p>
    {/if}

    <FormularovePolicko 
        labelTitle="Poznámka"
        placeholder="Zde můžete napsat poznámku k rezervaci"
        id="poznamka-zakaznika"
        type="textarea"
        bind:value={PoznamkaZakaznika} 
    />


    <div 
        style="display: flex; justify-content: center; align-items: center; gap: 1rem;"
        >
        <button type="submit">Rezervovat</button>
    </div>
</form>
{/if}

<style>

</style>